export default __webpack_public_path__ + "static/media/janod-geometric-shapes-3.a6744ffc.jpg";